export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11602.0cdc85b9.jpg";